import { render, staticRenderFns } from "./CustomizeMetalAQ.vue?vue&type=template&id=70c2a60d&scoped=true"
import script from "./CustomizeMetalAQ.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAQ.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAQ.vue?vue&type=style&index=0&id=70c2a60d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c2a60d",
  null
  
)

export default component.exports